import { useState, useEffect } from 'react';
import { supabase } from '../supabaseclient';
import { 
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
  PieChart, Pie, Legend
} from 'recharts';

export default function Dashboard({ perfil }) {
  const [abaAtiva, setAbaAtiva] = useState('beneficios');
  const [dadosItens, setDadosItens] = useState([]);
  const [dadosSocial, setDadosSocial] = useState([]); // Nova state para unidades sociais
  const [totalGeral, setTotalGeral] = useState(0);
  const [filtroDias, setFiltroDias] = useState(30);

  useEffect(() => {
    carregardadosdashboard();
  }, [filtroDias]);

  const carregardadosdashboard = async () => {
    const dataLimite = new Date();
    dataLimite.setDate(dataLimite.getDate() - filtroDias);
    const dataFormatada = dataLimite.toISOString().split('T')[0];

    // Buscas existentes
    const { data: concessoes } = await supabase.from('fundo_social_concessoes').select('tipo_atendimento, quantidade').gte('data_atual', dataFormatada);
    const { data: enxovais } = await supabase.from('Kit_enxoval').select('id').gte('created_at', dataFormatada);

    // NOVAS BUSCAS (Unidades Sociais)
    const { data: c1 } = await supabase.from('cras1_atendimentos').select('id').gte('data_atendimento', dataFormatada);
    const { data: c2 } = await supabase.from('cras2_atendimentos').select('id').gte('data_atendimento', dataFormatada);
    const { data: creas } = await supabase.from('creas_atendimentos').select('id').gte('data_atendimento', dataFormatada);

    // Processamento de Benefícios
    if (concessoes) {
      const resumo = concessoes.reduce((acc, curr) => {
        const nome = curr.tipo_atendimento || 'Outros';
        const existente = acc.find(item => item.name === nome);
        if (existente) { existente.quantidade += Number(curr.quantidade || 0); }
        else { acc.push({ name: nome, quantidade: Number(curr.quantidade || 0) }); }
        return acc;
      }, []);
      setDadosItens(resumo.sort((a, b) => b.quantidade - a.quantidade));
    }

    // Processamento das Unidades Sociais (Gráfico de Barras)
    const resumoSocial = [
      { name: 'CRAS 1', quantidade: c1?.length || 0 },
      { name: 'CRAS 2', quantidade: c2?.length || 0 },
      { name: 'CREAS', quantidade: creas?.length || 0 },
    ];
    setDadosSocial(resumoSocial);

    setTotalGeral((concessoes?.length || 0) + (enxovais?.length || 0) + (c1?.length || 0) + (c2?.length || 0) + (creas?.length || 0));
  };

  const CORES = ['#1e3a8a', '#16a34a', '#dc2626', '#f59e0b', '#7c3aed'];

  return (
    <div className="space-y-6">
      {/* Estilos e Cabeçalho de Impressão permanecem iguais... */}

      {/* MENU INTERNO COM NOVA ABA */}
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 bg-white p-2 rounded-2xl shadow-sm border border-gray-100 no-print">
        <div className="flex bg-gray-100 p-1 rounded-xl w-full md:w-auto">
          <button onClick={() => setAbaAtiva('beneficios')} className={`px-4 py-2 rounded-lg text-[10px] font-bold uppercase transition-all ${abaAtiva === 'beneficios' ? 'bg-white text-blue-900 shadow-sm' : 'text-gray-400'}`}>📦 Itens</button>
          <button onClick={() => setAbaAtiva('social')} className={`px-4 py-2 rounded-lg text-[10px] font-bold uppercase transition-all ${abaAtiva === 'social' ? 'bg-white text-blue-900 shadow-sm' : 'text-gray-400'}`}>🏠 Social</button>
        </div>
        
        <div className="flex items-center gap-3">
           <select value={filtroDias} onChange={(e) => setFiltroDias(Number(e.target.value))} className="bg-gray-100 border-none rounded-xl text-[10px] font-black p-2">
              <option value={7}>7 Dias</option>
              <option value={30}>30 Dias</option>
              <option value={90}>90 Dias</option>
           </select>
           <button onClick={() => window.print()} className="bg-blue-900 text-white px-4 py-2 rounded-xl text-[10px] font-black uppercase shadow-md">🖨️ Imprimir</button>
        </div>
      </div>

      {/* ÁREA DE GRÁFICOS DINÂMICA */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {abaAtiva === 'social' ? (
          <div className="bg-white p-6 rounded-[2rem] shadow-xl border border-gray-100 h-[400px] col-span-2">
            <p className="text-[10px] font-black text-gray-400 uppercase mb-6 text-center tracking-widest">Atendimentos por Unidade Assistencial</p>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={dadosSocial}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f4f6" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{fill: '#9ca3af', fontSize: 10, fontWeight: 'bold'}} />
                <YAxis axisLine={false} tickLine={false} />
                <Tooltip />
                <Bar dataKey="quantidade" radius={[10, 10, 0, 0]} barSize={60}>
                  {dadosSocial.map((e, i) => <Cell key={i} fill={CORES[i % CORES.length]} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        ) : (
          <div className="bg-white p-6 rounded-[2rem] shadow-xl border border-gray-100 h-[400px] col-span-2">
            <p className="text-[10px] font-black text-gray-400 uppercase mb-6 text-center tracking-widest">Benefícios Concedidos (Total Itens)</p>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={dadosItens}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="name" tick={{fontSize: 9, fontWeight: 'bold'}} />
                <YAxis />
                <Tooltip />
                <Bar dataKey="quantidade" radius={[10, 10, 0, 0]}>
                  {dadosItens.map((e, i) => <Cell key={i} fill={CORES[i % CORES.length]} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}
